import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/packages/electus/frontend/node_modules/next-intl/dist/esm/production/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/packages/electus/frontend/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/packages/electus/frontend/node_modules/next/dist/shared/lib/lazy-dynamic/preload-chunks.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/packages/electus/frontend/src/components/atoms/button/index.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/packages/electus/frontend/src/components/atoms/Image/index.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/packages/electus/frontend/src/components/atoms/link/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/packages/electus/frontend/src/components/atoms/toaster/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/packages/electus/frontend/src/components/molecules/article-card/index.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/packages/electus/frontend/src/components/molecules/section-header/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/packages/electus/frontend/src/components/organisms/category-cards-grid/components/category-card/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/packages/electus/frontend/src/components/organisms/content-items/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/packages/electus/frontend/src/components/organisms/content-slider/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/packages/electus/frontend/src/components/organisms/content-tiles/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/packages/electus/frontend/src/components/organisms/faq-section/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/packages/electus/frontend/src/components/organisms/footer/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/packages/electus/frontend/src/components/organisms/raw-html-embed/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["getAlgoliaSearchClient"] */ "/opt/build/repo/packages/electus/frontend/src/lib/algolia/client.ts");
;
import(/* webpackMode: "eager", webpackExports: ["initInsights","setAuthenticatedUser","getUserToken","trackClick","trackClickedFilters","trackView","trackConvert"] */ "/opt/build/repo/packages/electus/frontend/src/lib/algolia/insights.ts");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/packages/electus/frontend/src/lib/tastics/addresses/index.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/packages/electus/frontend/src/lib/tastics/approval-flow-details/components/approval-flows-client-wrapper/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/packages/electus/frontend/src/lib/tastics/approval-flows/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/packages/electus/frontend/src/lib/tastics/approval-rules/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/packages/electus/frontend/src/lib/tastics/article-detail/components/article-detail-client-wrapper/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/packages/electus/frontend/src/lib/tastics/articles-listing/components/articles-listing-client-wrapper/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/packages/electus/frontend/src/lib/tastics/banner/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/packages/electus/frontend/src/lib/tastics/blog/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/packages/electus/frontend/src/lib/tastics/cart/components/cart-client-wrapper/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/packages/electus/frontend/src/lib/tastics/checkout/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/packages/electus/frontend/src/lib/tastics/company-admin/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/packages/electus/frontend/src/lib/tastics/dashboard/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/packages/electus/frontend/src/lib/tastics/featured-carousel/components/featured-carousel-client-wrapper/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/packages/electus/frontend/src/lib/tastics/header/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/packages/electus/frontend/src/lib/tastics/hero-carousel/components/hero-carousel-client-wrapper/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/packages/electus/frontend/src/lib/tastics/hero-tile/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/packages/electus/frontend/src/lib/tastics/order-detail/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/packages/electus/frontend/src/lib/tastics/orders/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/packages/electus/frontend/src/lib/tastics/product-details/components/product-details-client-wrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/packages/electus/frontend/src/lib/tastics/product-list/components/product-list-client-wrapper/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/packages/electus/frontend/src/lib/tastics/product-slider/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/packages/electus/frontend/src/lib/tastics/purchase-list-detail/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/packages/electus/frontend/src/lib/tastics/purchase-lists/components/purchase-lists-client-wrapper/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/packages/electus/frontend/src/lib/tastics/quote-checkout/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/packages/electus/frontend/src/lib/tastics/quote-detail/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/packages/electus/frontend/src/lib/tastics/quote-request-detail/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/packages/electus/frontend/src/lib/tastics/quote-thank-you/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/packages/electus/frontend/src/lib/tastics/quotes/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/packages/electus/frontend/src/lib/tastics/related-products-slider/components/related-products-slider-client-wrapper/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/packages/electus/frontend/src/lib/tastics/settings/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/packages/electus/frontend/src/lib/tastics/thank-you/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/packages/electus/frontend/src/providers/tracing/index.tsx");
